import { Component, Input, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { Modalable } from "@app/Modalable"
import { PatientTestInvitesComponent } from "@app/patient-test-invites/patient-test-invites.component"
import { DateFormatPipe } from "@app/utils/date-format.pipe"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { TableWrapComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-testschedules",
	imports: [
		COMMON_IMPORTS,
		TableWrapComponent,
		GenButtonGroupComponent,
		DateFormatPipe,
		LangValPipe,
		ModalWrapComponent,
		PatientTestInvitesComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<app-table-wrap
			fieldsStr="name,start_date,is_fixed_interval,interval,repetitions,active,test_invites_log"
		>
			@for (row of rows; track row.id) {
				<tr>
					<td>{{ row.name }}</td>
					<td>{{ row.start_date | dateFormat }}</td>
					<td>{{ row.is_fixed_interval | langVal }}</td>
					<td>
						@if (row.is_fixed_interval === "yes") {
							{{ row.interval }}
						}
					</td>
					<td>
						@if (row.is_fixed_interval === "yes") {
							{{ row.repetitions }}
						}
					</td>
					<td>
						<app-gen-button-group
							[actualObj]="row"
							fieldName="active"
							optionsListName="yes_no_opts"
							(changeEvent)="update(row)"
						/>
					</td>
					<td>
						<button
							class="btn btn-primary"
							(click)="modalProps = { testschedule_id: row.id }"
						>
							{{ "test_invites_log" | langVal }}
						</button>
					</td>
				</tr>
			}
		</app-table-wrap>
		@if (modalProps) {
			<app-modal-wrap
				(onClose)="modalProps = null"
				title="test_invites_log"
			>
				<app-patient-test-invites
					(onClose)="modalProps = null"
					[patient_id]="patient_id"
					[testschedule_id]="modalProps.testschedule_id"
				/>
			</app-modal-wrap>
		}
	`,
})
export class TestschedulesComponent extends Modalable {
	modalProps: any = null
	@Input() patient_id: number
	rows: any = []

	ngOnInit() {
		this.rows = this.store
			.getSiteDataTable("testschedules")
			.filter(({ patient_id }) => this.patient_id == patient_id)
			.map((row) => ({
				...row,
				name: this.store.searchSiteDataItem(row.test_id, ["tests"])?.name,
			}))
	}
	async update(row: any) {
		const res = await this.apiService.save_gen_field(
			"testschedules",
			row.id,
			"active",
			row.active
		)
		if (res.success) {
			this.store.updGenItemRowField(
				"testschedules",
				row.id,
				"active",
				row.active
			)
			this.modalService.openToast("update_successfuly")
		}
	}
}
